import { Component } from "@angular/core";

@Component({
  selector: "audio-waveform-visualizer",
  templateUrl: "./audio-waveform-visualizer.component.svg",
})
export class AudioWaveformVisualizerSvg {}



// WEBPACK FOOTER //
// ./src/assets/svg/audio-waveform-visualizer/audio-waveform-visualizer.component.ts